// extracted by mini-css-extract-plugin
module.exports = {"makerWhite":"white","makerGreen":"#385461","footer":"footer_footer__1lZIc","title":"footer_title__pkoUs"};